import { API_BASE, publicRequest, request, resolveApiUrl } from './core.api';

export type DamageReportUrgency = 'Low' | 'Normal' | 'High' | 'Urgent';

export interface DamageReportPhotoDto {
  id: string;
  fileName: string;
  contentType: string;
  fileSizeBytes: number;
  downloadUrl: string;
  createdAt: string;
}

export interface DamageReportDto {
  id: string;
  rentalAgreementId: string;
  propertyId: string;
  propertyAddress: string;
  tenantId: string;
  tenantName: string;
  urgency?: DamageReportUrgency;
  description: string;
  createdAt: string;
  photos: DamageReportPhotoDto[];
}

export interface CreateDamageReportRequest {
  description: string;
  urgency?: DamageReportUrgency;
}

export interface CreateDamageReportPhotoRequest {
  fileName: string;
  contentType: string;
  fileSizeBytes: number;
}

export interface DamageReportPhotoUploadUrlDto {
  photoId: string;
  uploadUrl: string;
}

export const damageReportsApi = {
  list: () => request<DamageReportDto[]>('/damage-reports'),
  listByProperty: (propertyId: string) => request<DamageReportDto[]>(`/properties/${propertyId}/damage-reports`),
  createForTenantAgreement: (rentalAgreementId: string, data: CreateDamageReportRequest) =>
    request<DamageReportDto>(`/tenant-portal/rental-agreements/${rentalAgreementId}/damage-reports`, { method: 'POST', body: JSON.stringify(data) }),
  createPhotoUpload: (damageReportId: string, data: CreateDamageReportPhotoRequest) =>
    request<DamageReportPhotoUploadUrlDto>(`/tenant-portal/damage-reports/${damageReportId}/photos`, { method: 'POST', body: JSON.stringify(data) }),
  createForWelcomePage: (token: string, data: CreateDamageReportRequest) =>
    publicRequest<DamageReportDto>(`/welcome-pages/${encodeURIComponent(token)}/damage-reports`, { method: 'POST', body: JSON.stringify(data) }),
  createPublicPhotoUpload: (token: string, damageReportId: string, data: CreateDamageReportPhotoRequest) =>
    publicRequest<DamageReportPhotoUploadUrlDto>(`/welcome-pages/${encodeURIComponent(token)}/damage-reports/${damageReportId}/photos`, { method: 'POST', body: JSON.stringify(data) }),
  uploadPublicPhotoContent: async (token: string, damageReportId: string, photoId: string, file: File) => {
    const response = await fetch(resolveApiUrl(`/welcome-pages/${encodeURIComponent(token)}/damage-reports/${damageReportId}/photos/${photoId}/content`), {
      method: 'PUT',
      headers: {
        'Content-Type': file.type || 'application/octet-stream',
      },
      body: file,
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }
  },
};
